<template>
    <div class="login-container" ref="login">
        <el-form
            @click.native.stop=""
            autocomplete="on"
            :model="loginForm"
            ref="loginForm"
            :rules="loginRules"
            label-position="left"
            label-width="0px"
            class="card-box login-form"
        >
            <h3 class="title">SwiftInt 敏捷 EDI</h3>
            <el-form-item prop="username">
                <el-input
                    name="username"
                    type="text"
                    v-model="loginForm.username"
                    autocomplete="on"
                    placeholder="请输入用户名称"
                ></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    name="password"
                    type="password"
                    @keyup.enter.native="handleLogin"
                    v-model="loginForm.password"
                    autocomplete="on"
                    placeholder="请输入登录密码"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    type="primary"
                    style="width: 100%"
                    :loading="loading"
                    @click.native.prevent.stop="handleLogin"
                    >登录</el-button
                >
            </el-form-item>
        </el-form>
        <!-- <p class="company-desc">Copyright © www.qingjiao.com, All Rights Reserved.</p> -->
    </div>
</template>

<script>
import line from "./line";
export default {
    components: {},
    name: "login",
    data() {
    
        return {
            loginForm: {
                username: "",
                password: "",
            },
            loginRules: {
                username: [
                    {
                        required: true,
                        message: "账户不能为空",
                        trigger: "blur",
                    }
                ],
                password: [
                    {
                        required: true,
                        message: '密码不能为空',
                        trigger: "blur",
                    },
                ],
            },
            loading: false,
            showDialog: false,
        };
    },
    methods: {
        handleLogin() {
            this.$refs["loginForm"].validate((valid) => {
                if (valid) {
                    this.$http
                        .post(
                            `/login?username=${this.loginForm.username}&password=${this.loginForm.password}`
                        )
                        .then((res) => {
                            if (res.code != 200) {
                                this.$notify.error({
                                    title: "错误",
                                    message: "账号或密码错误",
                                });
                                return;
                            }

                            // let token = res.t;
                            localStorage.setItem("ediUsername", this.loginForm.username);
                            localStorage.setItem("sessionExpired", "false");
                            this.$router.push("/app/home");
                        });
                }
            });
        },
    },
    created() {},
    mounted() {
        line(this.$refs.login);
    },
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "./../assets/var.scss";
.tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 5px;
}
.company-desc {
    position: absolute;
    bottom: 37%;
    left: 43%;
    font-size: 12px;
    color: #cbeae4;
}
.login-container {
    height: 100vh;
    // background-image: linear-gradient(to top, #48c6ef 0%, #6f86d6 100%);
    background-image: linear-gradient(
        to top,
        #1e3c72 0%,
        #1e3c72 1%,
        #2a5298 100%
    );
    .title {
        font-size: 26px;
        font-weight: 400;
        color: $--color-primary;
        margin: 0 auto 40px;
        text-align: center;
        font-weight: bold;
        user-select: none;
    }
    .login-form {
        position: absolute;
        left: 0;
        right: 0;
        top: 7%;
        z-index: 2;
        width: 382px;
        padding: 35px 35px 15px;
        margin: 120px auto;
        background-color: #fff;
        border-radius: 5px;
    }
}
</style>
